import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import TemplateBox from "components/TemplateBox";
import { useTemplateController, setLayout } from "context";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function DashboardLayout({ bgColor, children, ...rest }) {
  const [controller, dispatch] = useTemplateController();
  const { darkMode } = controller;
  const { pathname } = useLocation();
  const theme = useTheme();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  // Cambia il colore di sfondo qui
  const background = darkMode && !bgColor ? "transparent" : "#00449E";

  return (
    <TemplateBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        pt: 0,
      })}
    >
      <TemplateBox
        bgColor={background || "info"}
        height={mobileDevice ? "120px" : "80px"}
        width="100%"
        position="absolute"
        top={0}
        left={0}
        sx={
          darkMode && {
            bgColor: ({ palette: { background } }) => background.default,
          }
        }
        {...rest}
      />
      {children}
    </TemplateBox>
  );
}

DashboardLayout.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
